// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"0408eaee","453":"303ebfe9","671":"ae1e40f1"}[chunkId] + ".chunk.js";
};